export default [
      {
        "id": "hobbies",
        "title": "Hobbies",
        "languagepoint": "Gerunds",
        
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "Talk about hobbies and free time while practicing gerunds.",
        "image": "/Images/hobbies.webp"
      }, 
    {
      "id": "historyofnutrition",
      "title": "History of Nutrition",
      "languagepoint": "Past Habits",
      
      "category": "Food",
      "level": "B2",
      "time": "",
      "description": "A lesson to talk about the history of nutrition",
      "image": "/Images/nutrition.webp"
    },
  {
      "id": "bucketList",
      "title": "Bucket List",
      "languagepoint": "Present Perfect",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Talking about bucket lists and life goals.",
      "image": "/Images/bucket.webp"
    },    
    {
      "id": "cashlesssociety",
      "title": "Cashless Society",
      "languagepoint": "Money Idioms & Expressions",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Talking about cash",
      "image": "/Images/cashless.webp"
    },    
    {
      "id": "beingbusy",
      "title": "Being Busy",
      "languagepoint": "Future Continuous vs. Future Perfect",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Talking about being busy.",
      "image": "/Images/busy.webp"
    }, 
    {
      "id": "socialetiquette",
      "title": "Social Etiquette",
      "languagepoint": "Conditionals",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Talking about etiquette.",
      "image": "/Images/fashion.webp"
    },
    {
      "id": "howthingswork",
      "title": "How Things Work",
      "languagepoint": "Verbs for Describing Device Actions",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Learn how everyday devices work and practice action verbs.",
      "image": "/Images/education1.webp"
    },
  {
        "id": "personality",
        "title": "Personality",
        "languagepoint": "Adjectives to Describe People",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about personality",
        "image": "/Images/argue4.webp"
      },  
      {
        "id": "weather",
        "title": "Weather",
        "languagepoint": "Conditionals",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "Explore extreme weather events while using mixed conditionals.",
        "image": "/Images/extremeweather.webp"
      },

    {
      "id": "companypolicy",
      "title": "Company Policy",
      "languagepoint": "Modals of Obligation, Permission, and Ability",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Talk about company policies and practices.",
      "image": "/Images/companypolicy1.webp"
    },
    {
      "id": "quality",
      "title": "The Quality of Stuff is Worse",
      "languagepoint": "Comparisons",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Compare quality standards in various industries.",
      "image": "/Images/fashion.webp"
    },
  
    {
      "id": "performancereview",
      "title": "Performance Reviews",
      "languagepoint": "Suggest, Recommend, Offer, Promise",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Learn how to give and receive advice using 'suggest'.",
      "image": "/Images/advice.webp"
    },
    {
      "id": "ethics",
      "title": "Ethics",
      "languagepoint": "Infinitives",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Explore ethical dilemmas and practice using infinitives.",
      "image": "/Images/eding1.webp"
    },
    {
      "id": "talenthardwork",
      "title": "Talent vs Hard Work",
      "languagepoint": "Conditionals",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Talk about talent vs hard work, nurture vs nature.",
      "image": "/Images/talent.webp"
    },
    {
      "id": "walking",
      "title": "Walking",
      "languagepoint": "Gerunds",
 
      "category": "Health",
      "level": "B2",
      "time": "",
      "description": "Talk about walking and its benefits while practicing gerunds.",
      "image": "/Images/walking.webp"
    },
  
  {
        "id": "entertainmentcost",
        "title": "The Cost of Entertainment",
        "languagepoint": "Passive",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about the cost of entertainment",
        "image": "/Images/entertainment.webp"
      },
  
  {
        "id": "memory",
        "title": "Memory",
        "languagepoint": "Verbs + Gerunds (remember doing)",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about memory",
        "image": "/Images/memory.webp"
      },
  {
        "id": "nospend",
        "title": "No Spend Trend",
        "languagepoint": "Word Forms",
 
        "category": "Money",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about spending habits",
        "image": "/Images/nospend.webp"
      },  
      {
        "id": "foodculture",
        "title": "Food Culture",
        "languagepoint": "Passive Reporting Verbs & 'Be Supposed To'",
  
        "category": "Food",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about food culture",
        "image": "/Images/foodculture1.webp"
      },  
  {
      "id": "funpsychology",
      "title": "Fun Psychology",
      "languagepoint": "Conditionals",
      
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Placeholder lesson about fun psychology topics.",
      "image": "/Images/fun-psychology.webp"
    },
  {
        "id": "endownership",
        "title": "The End of Ownership",
        "languagepoint": "Past Habits",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about the end of ownership",
        "image": "/Images/ownership.webp"
      },  
  {
        "id": "ailaw",
        "title": "AI and Work",
        "languagepoint": "Present Continuous",
 
        "category": "AI",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about AI laws",
        "image": "/Images/ailaw.webp"
      },
  {
        "id": "cars",
        "title": "Cars",
        "languagepoint": "Comparisons",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about cars",
        "image": "/Images/60bus-car-bike.webp"
      },  
  {
        "id": "solvingproblemdev",
        "title": "Solving Dev Problems",
        "languagepoint": "Conditionals",
 
        "category": "Tech",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about problem solving in development",
        "image": "/Images/problem-solving-dev.webp"
      },
  {
        "id": "procrastination",
        "title": "Procrastination",
        "languagepoint": "Second Conditional",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about procrastination",
        "image": "/Images/procrastination.webp"
      },
  {
        "id": "spirituality",
        "title": "Spirituality",
        "languagepoint": "Second Conditional",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about spirituality",
        "image": "/Images/spirituality.webp"
      },
  {
        "id": "goodmanager",
        "title": "Good Manager",
        "languagepoint": "Descriptive Adjectives",
 
        "category": "Business",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about management",
        "image": "/Images/officerules2.webp"
      },
  {
        "id": "alcohol",
        "title": "Alcohol",
        "languagepoint": "Passive",
 
        "category": "Food",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about alcohol",
        "image": "/Images/alcohol.webp"
      },
  {
        "id": "whatif",
        "title": "What If",
        "languagepoint": "3rd Conditional",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about what if scenarios",
        "image": "/Images/wish1.webp"
      },
  {
        "id": "businessscandals",
        "title": "Business Scandals",
        "languagepoint": "Second Conditional",
 
        "category": "Business",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about crazy business scandals",
        "image": "/Images/enron.webp"
      },
  {
        "id": "conspiracy",
        "title": "Conspiracy Theories",
        "languagepoint": "Modals of Deduction",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about crazy conspiracy theories",
        "image": "/Images/conspiracy.webp"
      },
  {
        "id": "salesdriving",
        "title": "Sales Driving",
        "languagepoint": "Comparisons",
 
        "category": "Business",
        "level": "A2",
        "time": "",
        "description": "A lesson to talk about driving",
        "image": "/Images/salesdriving.webp"
      },
  {
        "id": "cellphoneplane",
        "title": "Airplane Mode",
        "languagepoint": "Comparisons",
 
        "category": "Airtraffic",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about airplane mode",
        "image": "/Images/newyear2026-2.webp"
      },
  {
        "id": "newyear2026",
        "title": "New Year 2026",
        "languagepoint": "Future Tenses",
 
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about the new year 2026",
        "image": "/Images/newyear2026-2.webp"
      },
  {
        "id": "airtrafficsnow",
        "title": "Air Traffic 2026 Snow",
        "languagepoint": "Passive with 'Get'",
 
        "category": "Airtraffic",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about air traffic delays.",
        "image": "/Images/airsnow.webp"
      },
  {
        "id": "musicmemory",
        "title": "Music Memory",
        "languagepoint": "Gerunds vs. Infinitives",
        "category": "General",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about music memory",
        "image": "/Images/memory.webp"
      },
  {
        "id": "teambuilding",
        "title": "Team Building",
        "languagepoint": "Present Perfect",
 
        "category": "Business",
        "level": "B2",
        "time": "",
        "description": "A lesson to talk about team building",
        "image": "/Images/dogscatssmart.webp"
      },
  {
        "id": "belief",
        "title": "Belief",
        "languagepoint": "Used to, Be used to, Get used to",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about belief",
        "image": "/Images/belief.webp"
      },
  {
        "id": "giftgiving",
        "title": "Gift Giving",
        "languagepoint": "Unless",
 
        "category": "Holidays",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about gift giving",
        "image": "/Images/giftgivng.webp"
      },
  {
        "id": "holidays",
        "title": "Holidays",
        "languagepoint": "Cause and Effect",
 
        "category": "Holidays",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about holidays",
        "image": "/Images/OutofOffice.webp"
      },
  {
        "id": "tipping",
        "title": "Tipping",
        "languagepoint": "Sense Verbs",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about tipping",
        "image": "/Images/tipping.webp"
      },
  
  {
        "id": "sleep",
        "title": "Sleep",
        "languagepoint": "Infinitives",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about sleeping",
        "image": "/Images/sleep.webp"
      },
    {
        "id": "gambling",
        "title": "Gambling",
        "languagepoint": "Linking Words",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about gambling",
        "image": "/Images/gambling.webp"
      },
  {
        "id": "airtrafficfuture",
        "title": "The Future of Air Traffic Management",
        "languagepoint": "Future Tenses",
 
        "category": "Airtraffic",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about the future of ATM",
        "image": "/Images/airdelay1.webp"
      },
  {
        "id": "writing",
        "title": "The Future of Writing",
        "languagepoint": "Punctuation Rules",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about the future of writing",
        "image": "/Images/quiz1.webp"
      },
  {
        "id": "music",
        "title": "Is This Music?",
        "languagepoint": "Adverbs Modifying Adjectives",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about music vs noise",
        "image": "/Images/music-industry.webp"
      },
  {
        "id": "elections",
        "title": "Elections",
        "languagepoint": "Reported Speech",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to talk about the election system",
        "image": "/Images/voting.webp"
      },
  {
      "id": "value",
      "title": "What Makes Something Valuable",
      "languagepoint": "Unless",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Talk about value",
      "image": "/Images/value.webp"
    },  
  {
      "id": "corruption",
      "title": "Corruption",
      "languagepoint": "Modals of Obligation",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Talk about corruption in business with the example of Enron.",
      "image": "/Images/enron.webp"
    },  
  {
      "id": "parenting",
      "title": "Parenting",
      "languagepoint": "Gerunds vs. Infinitives",
 
      "category": "Education",
      "level": "B2",
      "time": "",
      "description": "Compare quality standards in various industries.",
      "image": "/Images/parents1.webp"
    },
    {
      "id": "airtraffic",
      "title": "Air Traffic",
      "languagepoint": "Second Conditional",
 
      "category": "Airtraffic",
      "level": "B2",
      "time": "",
      "description": "Compare quality standards in various industries.",
      "image": "/Images/airdelay1.webp"
    },

    {
      "id": "streamingServices",
      "title": "Streaming Services",
      "languagepoint": "",
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Talk about the future of streaming services.",
      "image": "/Images/streaming1.webp"
    },
    
    {
      "id": "sidejobs",
      "title": "Side Jobs",
      "languagepoint": "Comparisons",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Talk about working a side job.",
      "image": "/Images/homebakery2.webp"
    },
    {
      "id": "branding",
      "title": "Branding",
      "languagepoint": "Dependent Prepositions",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Explore branding strategies while practicing dependent prepositions.",
      "image": "/Images/Iconic_Logos.webp"
    },
    {
      "id": "smartphones",
      "title": "Cell Phones",
      "languagepoint": "Comparisons",
 
      "category": "General",
      "level": "B1",
      "time": "",
      "description": "A discussion on the role of smart phones in modern communication.",
      "image": "/Images/cellphone1.webp"
    },
    {
      "id": "money",
      "title": "Money Motivation",
      "languagepoint": "Modal Verbs for Advice",
 
      "category": "Money",
      "level": "B2",
      "time": "",
      "description": "Discuss what motivates people financially and explore related vocabulary.",
      "image": "/Images/money-motivation-1.webp"
    },
    {
      "id": "meetings",
      "title": "Meetings",
      "languagepoint": "Third Conditional",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Improve your ability to deduce meaning in professional meetings.",
      "image": "/Images/teams-meeting.webp"
    },
    {
      "id": "workfuture",
      "title": "Work Future",
      "languagepoint": "Future Tenses",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Discuss future trends in work and practice future tenses.",
      "image": "/Images/future1.webp"
    },
    {
      "id": "fastfood",
      "title": "Fast Food",
      "languagepoint": "Present Perfect vs Simple Past",
 
      "category": "Food",
      "level": "B1",
      "time": "",
      "description": "Explore the fast food industry and its impact on society.",
      "image": "/Images/fastfood1.webp"
    },
    {
      "id": "caffeine",
      "title": "Coffee",
      "languagepoint": "Third Conditional",
 
      "category": "Food",
      "level": "B2",
      "time": "",
      "description": "Discuss coffee culture and the effects of caffeine.",
      "image": "/Images/caffeine1.webp"
    },
    {
      "id": "newyearsresolution",
      "title": "New Year's Resolutions",
      "languagepoint": "",
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Set and discuss New Year's resolutions while practicing future plans.",
      "image": "/Images/resolution1.webp"
    },
    {
      "id": "habits",
      "title": "Habits",
      "languagepoint": "Past Habits",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Learn how to talk about personal and professional habits.",
      "image": "/Images/habits1.webp"
    },
    {
      "id": "chatplatforms",
      "title": "Chat Platforms",
      "languagepoint": "So, Such, Too, Enough",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Discuss chat platforms while learning how to use 'so' and 'enough'.",
      "image": "/Images/chatapps.webp"
    },
    {
      "id": "automation",
      "title": "Automation",
      "languagepoint": "Passive",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Explore automation trends and practice passive structures.",
      "image": "/Images/selfcheckout.webp"
    },
    {
      "id": "choice",
      "title": "Choice",
      "languagepoint": "Wish, If Only, and Hope",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Discuss choices in business and express wishes and regrets.",
      "image": "/Images/choice1.webp"
    },
    {
      "id": "competition",
      "title": "Competition",
      "languagepoint": "",
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Learn about competition and aviation safety with the second conditional.",
      "image": "/Images/airdelay1.webp"
    },
    {
      "id": "pets",
      "title": "Pets",
      "languagepoint": "Used to vs. Would vs. Be used to",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Learn about pet ownership and practice 'so' and 'enough'.",
      "image": "/Images/dogscatssmart.webp"
    },
    {
      "id": "people",
      "title": "People",
      "languagepoint": "Relative Clauses",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Describe people using relative clauses.",
      "image": "/Images/talkingchildren1.webp"
    },
    {
      "id": "neighbors",
      "title": "Neighbors",
      "languagepoint": "Conditionals",
 
      "category": "General",
      "level": "B2",
      "time": "",
      "description": "Discuss neighborly issues while practicing the 2nd conditional.",
      "image": "/Images/neighbors1.webp"
    },
    {
      "id": "food",
      "title": "Food",
      "languagepoint": "Passive",
      
      "category": "Food",
      "level": "B2",
      "time": "",
      "description": "Talk about food production and use the passive voice.",
      "image": "/Images/utensils1.webp"
    },
    {
      "id": "tourism",
      "title": "Tourism",
      "languagepoint": "Future Tenses",
 
      "category": "Travel",
      "level": "B2",
      "time": "",
      "description": "Discuss tourism and its impact while practicing gerunds.",
      "image": "/Images/budapest-tourism-crowd.webp"
    },
    {
      "id": "gossip",
      "title": "Gossip",
      "languagepoint": "Reported Speech",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Discuss workplace gossip while practicing reported speech.",
      "image": "/Images/gerunds1.webp"
    },
    {
      "id": "sustainability",
      "title": "Sustainability",
      "languagepoint": "Unless",
 
      "category": "Environment",
      "level": "B2",
      "time": "",
      "description": "Explore sustainability practices while learning how to use 'unless'.",
      "image": "/Images/techpeople1.webp"
    },
    {
      "id": "problemsolving",
      "title": "Problem Solving",
      "languagepoint": "Modals of Deduction",
 
      "category": "Business",
      "level": "B2",
      "time": "",
      "description": "Practice problem-solving strategies and modals of deduction.",
      "image": "/Images/problem-solving.webp",
    },
    {
      "id": "medicine",
      "title": "Medicine",
      "languagepoint": "Unless",
 
      "category": "Health",
      "level": "B2",
      "time": "",
      "description": "Discuss medical advancements and their ethical implications.",
      "image": "/Images/sense1.webp"
    },
    {
        "id": "persuading",
        "title": "Persuading",
        "languagepoint": "Word Forms",
 
        "category": "Business",
        "level": "B2",
        "time": "",
        "description": "Learn persuasive techniques while practicing different word forms.",
        "image": "/Images/sense2.webp"
      },
      {
        "id": "sports",
        "title": "Sports",
        "languagepoint": "Present Perfect",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "Discuss sports experiences while practicing the present perfect tense.",
        "image": "/Images/sports.webp"
      },
      {
        "id": "education",
        "title": "Education",
        "languagepoint": "Third Conditional",
 
        "category": "Education",
        "level": "B2",
        "time": "",
        "description": "Talk about past educational experiences and express wishes and regrets.",
        "image": "/Images/education1.webp"
      },
      {
        "id": "language",
        "title": "Language",
        "languagepoint": "Tense Review",
        
        "category": "Education",
        "level": "C1",
        "time": "",
        "description": "Talk about learning languages and review English verb tenses.",
        "image": "/Images/education1.webp"
      },
      {
        "id": "introlesson",
        "title": "Introduction",
        "languagepoint": "Introductions and Self-Description",
 
        "category": "General",
        "level": "B1",
        "time": "",
        "description": "A lesson to assess students' understanding of various tenses.",
        "image": "/Images/Getting-to-know-you.webp"
      }
  ]
  
